import React, { useState } from "react";
import { Modal, Image, Button, ModalHeader, ModalBody, Col, ModalFooter,Row } from "react-bootstrap";
import { 
  BsWhatsapp,
  BsTelephone
 } from "react-icons/bs";
import { FaRegPaperPlane } from "react-icons/fa"; 
import { AiOutlineMail } from "react-icons/ai";
import pngFile1 from "./Q/1v1.jpg";
import pngFile2 from "./Q/2v1.jpg";
import pngFile3 from "./Q/3v1.jpg";
import pngFile4 from "./Q/4v1.jpg";
import pngFile5 from "./Q/5v1.jpg";
import pngFile6 from "./Q/6v1.jpg";

import "./ImageModal.css";

function ImageModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>

     <a onClick={handleShow}>
              <Button
  variant="primary"
  target="_blank"
  style={{
  }}
>
  ПОДРОБНЕЕ
</Button>
      </a>
      <Modal show={show} onHide={handleClose} size="lg" style={{ paddingTop:"7em" }}>
       <ModalHeader style={{ fontSize:"1.3em" }}>Quarencia</ModalHeader>
       <ModalBody>
       <Image src={pngFile1} style={{ paddingBottom:"1em" }} alt="White Estate" fluid />
       <Image src={pngFile2} style={{ paddingBottom:"1em" }} alt="White Estate" fluid />
       <Image src={pngFile3} style={{ paddingBottom:"1em" }} alt="White Estate" fluid />
       <Image src={pngFile4} style={{ paddingBottom:"1em" }} alt="White Estate" fluid />
       <Image src={pngFile5} style={{ paddingBottom:"1em" }} alt="White Estate" fluid />
       <Image src={pngFile6} style={{ paddingBottom:"1em" }} alt="White Estate" fluid />
       <Col style={{ paddingTop:"5%" }}>
        <div>Комплекс "Querencia" предлагает роскошную жизнь в курортном стиле в самом модном регионе, в 400 метрах от живописного пляжа Long beach (Лонг бич) в Искеле напротив двух пятизвездочных отелей с казино на первой береговой линии.</div>
        <br />
        <div>Наличие двух пятизвездочных отелей с казино на первой береговой линии напротив проекта придает ему особую привлекательность и делает его идеальным вариантом для инвестиций.</div>
        <br />
        <div>Querencia состоит из четырех башен разной этажности, одна из которых будет роскошным отелем. В комплексе будет 686 комфортабельных апартаментов различных типов: студии, 1+1, 2+1, 3+1, а также шикарные пентхаусы 4+1 и 5+1.</div>
        <br />
        <div>Инфраструктура комплекса:</div>
        <br />
        <div>-открытые и крытые бассейны площадью более 1300 м2,</div>
        <div>- Инфинити бассейн на крыше 10-го этажа,</div>
        <div>-аквапарк для детей,</div>
        <div>-коворкинг и досуговые зоны, конференц-залы,</div>
        <div>-пункт обмена валют,</div>
        <div>-кинотеатр,</div>
        <div>-рестораны лучших кухонь мира и зал шведского завтрака,</div>
        <div>- снэк-бар,</div>
        <div>-тренажерный зал и спа-комплекс</div>
        <div>- турецкий хамам, паровые, массажные комнаты.</div>
        <br />
        <div>Своя управляющая компания обеспечивает контроль над сохранностью актива в период сдачи недвижимости в аренду и предоставляют отчеты о загрузке.</div>
        <br />
        <div>В комплексе будет реализована возможность отдыха на открытом воздухе – зоны активного отдыха для детей, спортивные и игровые площадки, баскетбольная площадка, сквош-корт и теннисный корт, пешеходные и велосипедные дорожки. Резидентам комплекса будет доступен подземный переход к пляжной инфраструктуре.</div>
        <br />
        <div>План оплаты: </div>
        <br />
        <div>-5% депозит от стоимости недвижимости,</div>
        <div>-35% первоначальный взнос,</div>
        <div>-60% беспроцентная рассрочка до конца строительства и год после получения ключей.</div>
<br />
<div>Срок сдачи: июнь 2025 г. - сентябрь 2026 г.</div>
       </Col>
       </ModalBody>
       <ModalFooter style={{ justifyContent:"center" }}>
        <div>
              <li className="social-icons">
                <a
                  href="mailto:kseniya@whiteestate.co"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="email"
                >
                  <AiOutlineMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://api.whatsapp.com/send?phone=905338651575"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="whatsapp"
                >
                  <BsWhatsapp />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://t.me/cavalle"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="telegram"
                >
                  <FaRegPaperPlane />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="tel:+905338651575"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="telephone"
                >
                  <BsTelephone/>
                </a>
              </li>
        </div>
       </ModalFooter>
      </Modal>
    </>
  );
}

export default ImageModal;
